import React from 'react'
import Autocomplete from '../../../components/Autocomplete'
import { riscoRepository } from '../RiscoRepository'

const toOptionRisco = risco => {
  const label = `${risco.numero} - ${risco.descricao}`
  return { id: risco.id, value: risco.id, label }
}

export const loadRiscos = async inputValue => {
  const response = await riscoRepository.listCustomer({
    value: inputValue,
    limit: 10
  })
  if (response.ok) {
    return response.data.map(toOptionRisco)
  }
  return []
}

const labelFormat = data => {
  if (!Array.isArray(data) && data) {
    return toOptionRisco(data)
  }
}

const RiscoAutocomplete = props => {
  const loadOptions = loadRiscos

  return (
    <Autocomplete
      {...props}
      repository={riscoRepository}
      labelFormat={labelFormat}
      loadOptions={loadOptions}
    />
  )
}

export { RiscoAutocomplete }
